// A socket.io-shaped object with no network: the demo's generator/driver FIRE the same events the real server emits, and the real AnalyticsView handlers receive them.
type Handler = (payload: any) => void;

export const createFakeSocket = () => {
  const handlers = new Map<string, Handler[]>();
  const socket = {
    id: "demo-socket",
    connected: true,
    disconnected: false,
    on(event: string, cb: Handler) { handlers.set(event, [...(handlers.get(event) || []), cb]); return socket; },
    off(event: string, cb?: Handler) { handlers.set(event, cb ? (handlers.get(event) || []).filter((h) => h !== cb) : []); return socket; },
    once(event: string, cb: Handler) { const h: Handler = (p) => { socket.off(event, h); cb(p); }; return socket.on(event, h); },
    emit(..._args: unknown[]) { return socket; },
    connect() { return socket; },
    disconnect() { return socket; },
    removeAllListeners() { handlers.clear(); return socket; },
    /** demo only: deliver a server event to the real listeners */
    fire(event: string, payload: unknown) { (handlers.get(event) || []).forEach((h) => h(payload)); },
  };

  return socket;
};
export type FakeSocket = ReturnType<typeof createFakeSocket>;
